
import { gbLocalStorage } from '~/utils/helpers'

export default {
  name: 'TrajectoryCards',
  props: {
    trajectories: {
      type: Object,
      required: true
    },

    value: {
      type: String,
      required: true
    }
  },

  computed: {
    selectedTrajectory: {
      get() {
        return this.value
      },

      set(trajectory) {
        gbLocalStorage.set('education-trajectory', trajectory)
        this.$emit('input', trajectory)
      }
    }
  },

  methods: {
    setTrajectory(val) {
      this.selectedTrajectory = val
    },

    checkIsTrajectorySelected(trajectory) {
      return this.selectedTrajectory === trajectory
    }
  }
}
